import script from "./Historial.vue?vue&type=script&setup=true&lang=js"
export * from "./Historial.vue?vue&type=script&setup=true&lang=js"

import "./Historial.vue?vue&type=style&index=0&id=530326da&lang=css"

const __exports__ = script;

export default __exports__